export default __webpack_public_path__ + "static/media/gallery-wip-emitter_02.90389c16.jpg";